<template>
    <div class="gallery-message">
        <div class="prev" @click="prevCard" v-if="currentIndex !== 0">
            <md-button class="md-icon-button">
                <md-icon class="btn-arrow-back-ios">
                    arrow_back_ios
                </md-icon>
            </md-button>
        </div>
        <div class="cards" ref="cardContainer">
            <GalleryImageCard
                v-for="(card, index) in items"
                :key="'card-' + index"
                :card="card"
                ref="cardRefs"
                :current="index === currentIndex"
                :conversation-id="conversationId"
                :block-id="data.raw.payload.blockId"
                :payload-id="data.raw.payload.id"
                :uniq-message-id="data.raw.uniqMessageId"
                @click="() => cardClick(index)"
                :disabled="disabled"
            />
        </div>
        <div class="next">
            <md-button class="md-icon-button" @click="nextCard" v-if="currentIndex !== items.length - 1">
                <md-icon class="btn-arrow-forward-ios">arrow_forward_ios</md-icon>
            </md-button>
        </div>
    </div>
</template>

<script>
import GalleryImageCard from "./GalleryImageCard";
import _ from "lodash";

export default {
    name: "BotGalleryMessage",
    components: { GalleryImageCard },
    props: ["data", "disabled"],
    data() {
        return {
            items: _.get(this.data, "raw.payload.cards", []),
            conversationId:
                this.data.raw.conversationId || _.get(this.data.raw.conversation, "_id", this.data.raw.conversation),
            currentIndex: 0,
        };
    },
    methods: {
        scrollToCard() {
            const isLast = this.currentIndex === this.items.length - 1;
            this.$refs.cardContainer.scroll(280 * this.currentIndex - (isLast ? 0 : 80), 0);
        },
        cardClick(index) {
            this.currentIndex = index;
            this.scrollToCard();
        },
        nextCard() {
            if (this.currentIndex < this.items.length - 1) {
                this.currentIndex++;
                this.scrollToCard();
            }
        },
        prevCard() {
            if (this.currentIndex > 0) {
                this.currentIndex--;
                this.scrollToCard();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.btn-arrow-back-ios {
    display: flex !important;
    margin-right: -8px !important;
    color: var(--button-color) !important;
}

.btn-arrow-forward-ios {
    display: flex !important;
    color: var(--button-color) !important;
}
.gallery-message {
    overflow: hidden;
    scroll-behavior: smooth;

    .cards {
        display: flex;
        flex-wrap: nowrap;
        gap: 20px;
        overflow: hidden;
        width: 100%;
        scroll-behavior: smooth;
        //border: 1px solid red;
        position: relative;
    }

    .controls {
        border: 1px solid green;
    }

    .prev,
    .next {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 40px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        .md-button {
            background: white;
            box-shadow: 0 0 15px 0 rgb(0 0 0 / 50%);
            padding: 5px !important;
            border-radius: 50% !important;
            font-style: normal !important;

            .md-icon {
                font-size: 35px !important;
                font-style: normal !important;
            }
        }

        //border: 1px solid green;
    }

    .prev {
        left: 0;
    }

    .next {
        right: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/messages/chatbot/BotGalleryMessage.vue